import React, { useEffect, useState } from 'react';
import { Button, Result } from 'antd';
import { useLocation } from 'react-router-dom';
import './AuthSuccess.style.css';
import { DEPLOY_TYPE, DOMAIN_URL } from 'utils';

const AuthSuccess = () => {
  /* ===== ROUTE ===== */
  const location = useLocation();

  /* ===== STATE ===== */
  const [isClose, setIsClose] = useState(false);

  /* ===== FUNCTION ===== */
  /**
   * 데이터 전송
   * --
   */
  const handleClose = () => {
    const queryString = new URLSearchParams(location.search);
    const encodeData = queryString.get('EncodeData');

    const authData = {
      type: 'AUTH',
      status: 'success',
      data: encodeData,
    };

    const port = DEPLOY_TYPE === 'local' ? ':3000' : '';

    // React Native WebView 인지 체크
    const isNative = window.ReactNativeWebView;

    if (isNative) {
      // Pass APP
      window.ReactNativeWebView.postMessage(`${JSON.stringify(authData)}`);
    } else {
      if (!isClose) {
        const domain =
          DEPLOY_TYPE === 'development'
            ? `mall-${DOMAIN_URL}`
            : `mall.${DOMAIN_URL}`;

        window.opener.postMessage(
          authData,
          `${window.location.protocol}//${domain}${port}`
        );
      }

      window.close();
      setIsClose(true);
    }
  };

  /**
   * 팝업창 닫기 감지
   * --
   */
  useEffect(() => {
    window.addEventListener('beforeunload', handleClose);

    return () => window.removeEventListener('beforeunload', handleClose);
    // eslint-disable-next-line
  }, []);

  /* ===== HOOKS ===== */
  return (
    <div className="auth-layout">
      <Result
        status={'success'}
        title={'인증성공'}
        subTitle={'페이지로 돌아가 다음 단계를 진행하세요.'}
        extra={[
          <Button className="auth-button" onClick={() => handleClose()}>
            돌아가기
          </Button>,
        ]}
      />
    </div>
  );
};

export default AuthSuccess;
